import { SvgIcon } from '@mui/material'
import type { SvgIconProps } from '@mui/material/SvgIcon'

export const LogoutIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon {...props} viewBox="0 0 36 36" fill="none" >
            <path d="M26 10V6C26 4.34315 24.6569 3 23 3H9C7.34315 3 6 4.34315 6 6V30C6 31.6569 7.34315 33 9 33H23C24.6569 33 26 31.6569 26 30V26" stroke="#16191E" strokeWidth="2" strokeLinecap="round" />
            <path d="M15.5 18L32 18" stroke="black" strokeWidth="2" strokeLinecap="round" />
            <path d="M29 15L32 18L29 21" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </SvgIcon>
  )
}
